const DarkMode = {};

{
    const _switchToDarkTheme = () => {
        html.addClass('dark-mode');
        $('.mode-switch .toggle-label').text('Light');
        currentTheme = 'dark';
    }

    const _switchToLightTheme = () => {
        html.removeClass('dark-mode');
        $('.mode-switch .toggle-label').text('Dark');
        currentTheme = 'light';
    }

    const _darkModeAddListener = () => {
        $('.mode-switch').on('click', function () {
            if (currentTheme === 'dark') {
                _switchToLightTheme();
                localStorage.setItem('alto_theme', 'light');
            } else {
                _switchToDarkTheme();
                localStorage.setItem('alto_theme', 'dark');
            }
            Comments?.changePalletHyvorTalk?.();
        });
    };

    const _checkDarkMode = () => {
        if (currentTheme === 'dark') {
            _switchToDarkTheme();
        } else {
            _switchToLightTheme();
        }
    };

    DarkMode.init = () => {
        _darkModeAddListener();
        _checkDarkMode();
    };
}